/* fizzy-mission-product-tabs.js
   Tab switching with ARIA + keyboard support for fizzy-mission-product-tabs.liquid.
   Vanilla JS, loaded with defer. Supports multiple section instances per page.
*/
(function () {
  'use strict';

  function initTabGroup(section) {
    var tablist = section.querySelector('[data-fmpt-tablist]');
    if (!tablist) return;

    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-fmpt-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-fmpt-panel]'));
    if (!tabs.length || !panels.length) return;

    function activate(index, focusTab) {
      tabs.forEach(function (tab, i) {
        var selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        if (selected && focusTab) tab.focus();
      });

      panels.forEach(function (panel, i) {
        if (i === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        activate(i, false);
      });

      tab.addEventListener('keydown', function (e) {
        var last = tabs.length - 1;
        var next = null;

        switch (e.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = i === last ? 0 : i + 1;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = i === 0 ? last : i - 1;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = last;
            break;
          default:
            return;
        }

        e.preventDefault();
        activate(next, true);
      });
    });
  }

  function init() {
    var sections = document.querySelectorAll('.fmpt');
    Array.prototype.forEach.call(sections, initTabGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when re-rendered in the Shopify theme editor.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.fmpt');
      if (section) initTabGroup(section);
    });
  }
})();
